import { useState, useEffect, useCallback } from "react";
import { api } from "./api";

export function useFetch(path, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    let active = true;
    setLoading(true);
    api
      .get(path)
      .then((r) => active && setData(r.data))
      .catch((e) => active && setError(e))
      .finally(() => active && setLoading(false));
    return () => (active = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  useEffect(() => {
    const cleanup = reload();
    return cleanup;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error, reload };
}
